<template>
  <div class="my-12" style="background-color: #F8F8F8;margin-bottom: 10rem">
    <div class="text-center mb-4">
      <span class="text-uppercase txt-large">{{ $t("contact") }}</span>
    </div>

    <v-layout class="justify-center">
      <v-flex xs10>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1937.9319418799357!2d100.51460065803644!3d13.726689597590925!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29f022db566ff%3A0x287c0f1b5fbe26f3!2z4Lio4Li54LiZ4Lii4LmM4Liq4Lij4LmJ4Liy4LiH4Liq4Lij4Lij4LiE4LmM4LiH4Liy4LiZ4Lit4Lit4LiB4LmB4Lia4LiaIFRDREM!5e0!3m2!1sth!2sth!4v1594377418907!5m2!1sth!2sth"
          width="100%"
          height="550"
          frameborder="0"
          style="border:0;"
          allowfullscreen=""
          aria-hidden="false"
          tabindex="0"
        >
        </iframe>
      </v-flex>
    </v-layout>

    <v-layout class="justify-center" mt-6 style="padding-bottom: 10rem">
      <v-flex xs10>
        <div class="mb-4" style="font-size: 20px;">
          {{ $t("contact-information") }}
        </div>

        <v-layout wrap>
          <v-flex class="lg6 md6 sm12 xs12 mb-4">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-card flat>
                <loading
                  color="#FD5246"
                  :active.sync="isLoading"
                  :can-cancel="false"
                  :is-full-page="false"
                ></loading>

                <v-layout
                  class="pa-6"
                  column
                  style="background-color: rgba(188,188,188,0.74);color: #000"
                >
                  <v-flex>
                    <div>
                      {{ $t("contact-name") }} <span style="color: red">*</span>
                    </div>
                    <v-text-field
                      flat
                      solo
                      dense
                      v-model="form.name"
                      :rules="nameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <div>
                      {{ $t("contact-email") }}
                      <span style="color: red">*</span>
                    </div>
                    <v-text-field
                      flat
                      solo
                      dense
                      v-model="form.email"
                      :rules="emailRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <div>{{ $t("contact-phone-number") }}</div>
                    <v-text-field
                      flat
                      solo
                      dense
                      v-model="form.mobile_number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <div>{{ $t("contact-reason") }}</div>
                    <v-select
                      color="#FD5246"
                      placeholder="Please select"
                      solo
                      dense
                      flat
                      v-model="form.reason_contact"
                      :items="reason_contact_list"
                      item-value="id"
                      item-text="reason_name"
                      menu-props="offset-y"
                    ></v-select>
                  </v-flex>
                  <v-flex>
                    <div>
                      {{ $t("contact-details") }}
                      <span style="color: red">*</span>
                    </div>
                    <v-textarea
                      flat
                      solo
                      dense
                      v-model="form.detail"
                      :rules="detailRules"
                      rows="3"
                    ></v-textarea>
                  </v-flex>

                  <v-flex>
                    <v-layout>
                      <v-flex shrink class="mr-3">
                        <v-btn
                          color="#FD5246"
                          :disabled="!valid"
                          @click="validate"
                          dark
                          depressed
                          tile
                          >{{ $t("contact-send") }}
                        </v-btn>
                      </v-flex>
                      <v-flex
                        class="d-flex align-center"
                        shrink
                        style="font-size: 12px;"
                      >
                        <span style="color: #FD5246">* </span>
                        <span style="color: #79777a">Required fields.</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-form>
          </v-flex>

          <v-flex class="lg6 md6 sm12 xs12 px-6">
            <div class="mb-4">
              <i>
                We’d love to hear from you. Simply complete the form below. If
                you have a question or enquiry, one of our team member will get
                back to you ASAP.
              </i>
            </div>

            <div class="mb-4">
              <div class="font-weight-bold">
                Creative Economy Agency (Public Organization)
              </div>
              <div>
                The Grand Postal Building 1160 Charoenkrung Road, Bangrak
                Bangkok 10501 Formal address for sending documents and issuing
                receipts and tax documents
              </div>
              <div>Email: connect@cea.or.th</div>
            </div>

            <div>
              <div class="font-weight-bold mb-4">Back Office</div>
              <div class="mb-4">
                2nd Fl. The Grand Postal Building 1160 Charoenkrung Road,
                Bangrak Bangkok 10501
              </div>

              <div>Tel. (+66) 2 105 7400</div>
              <div>Fax. (+66) 2 105 7450</div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import { domain, imgPath } from "../services/Constants";

export default {
  name: "Contact",
  components: {
    Loading,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    valid: true,
    nameRules: [(v) => !!v || "Name is required"],
    detailRules: [(v) => !!v || "Detail is required"],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    form: {
      name: "",
      email: "",
      mobile_number: "",
      reason_contact: "",
      detail: "",
    },
    captcha: null,
    reason_contact_list: [],
  }),
  created() {
    this.getContactList();
  },
  methods: {
    getContactList() {
      axios({
        url: `${domain}api/get-contact-list`,
        method: "GET",
      }).then((res) => {
        this.reason_contact_list = res.data;
      });
    },
    validate() {
      this.$refs.form.validate();
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        this.$store
          .dispatch("contact/saveContact", this.form)
          .then((res) => {
            this.isLoading = false;
            if (res.status === 200) {
              this.$swal({
                icon: "success",
                text: this.$t("contact-send-success"),
                confirmButtonColor: "#FD5246",
                confirmButtonText: "ตกลง",
              });
            } else {
              this.isLoading = false;
              this.$swal({
                icon: "error",
                text: this.$t("contact-send-error"),
                confirmButtonColor: "#FD5246",
                confirmButtonText: "ตกลง",
              });
            }
          })
          .catch((err) => {
            this.isLoading = false;
            this.$swal({
              icon: "error",
              text: this.$t("contact-send-error"),
              confirmButtonColor: "#FD5246",
              confirmButtonText: "ตกลง",
            });
          });
      } else {
        this.$swal({
          icon: "error",
          text: "กรอกข้อมูลให้ครบ",
          confirmButtonColor: "#FD5246",
          confirmButtonText: "ตกลง",
        });
      }
    },
  },
};
</script>

<style scoped></style>
